import { createAction } from '@reduxjs/toolkit'

export const sessionRejected = createAction('platform/sessionRejected')
